module.exports = __webpack_public_path__ + "front/img/127d03fc.swf";


/*****************
 ** WEBPACK FOOTER
 ** ./components/Video/jwplayer/jwplayer.flash.swf
 ** module id = 73
 ** module chunks = 0
 **/